import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StatusBag } from '@app/enums';
import { Passenger as PassengerOld } from '@app/models';
import { Passenger } from '@app/models/micro';
import { Reservation as ReservationOld } from '@app/models/reservation.model';
import { GlobalsService as GlobalServ } from '@app/services/globals.service';
/**
 * Componente para agregar equipaje de mano adicional.
 *
 * Este componente permite a los usuarios seleccionar si desean agregar peso extra
 * a su equipaje de mano. Emite un evento cuando se realiza un cambio en la selección.
 */
@Component({
  selector: 'am-bag-add-carryon',
  templateUrl: './am-bag-add-carryon.component.html',
  styleUrls: ['./am-bag-add-carryon.component.scss'],
  standalone: false,
})
export class AmBagAddCarryonComponent implements OnInit {
  @Input() passengersCarryOn: Passenger[];
  @Input() passengerCarryOn: Passenger;
  /**
   * Estado actual del equipaje de mano.
   * Recibe un valor del enum StatusBag.
   */
  @Input() statusBag: StatusBag;
  /**
   * Habilita el checkbox para carryon-classic
   * Cuando es true, muestra checkbox en lugar de texto informativo
   */
  @Input() enableCheck: boolean = false;
  @Input() fareFamily: string; // Added for fare validation
  @Input() connectionBlocked = false;

  /**
   * Evento que se emite cuando el usuario cambia la selección de peso extra.
   * Envía un valor booleano indicando si se ha seleccionado peso adicional.
   *
   */
  @Output() onChangeExtraWeight: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onConnectionBlocked: EventEmitter<void> = new EventEmitter<void>();
  reservationold: ReservationOld;
  /**
   * Referencia local al enum StatusBag para usar en la plantilla.
   */
  StatusBag = StatusBag;
  constructor(private _globalServiceOld: GlobalServ) {}

  ngOnInit(): void {
    this.reservationold = this._globalServiceOld.getReservation();
  }

  /**
   * Maneja el cambio del checkbox
   * Solo se usa cuando enableCheck=true (carryon-classic)
   */
  onHandleCheck(value: boolean) {
    if (this.connectionBlocked) {
      return;
    }
    this.onChangeExtraWeight.emit(value);
  }

  onDisabledCheckClick() {
    this.onConnectionBlocked.emit();
  }

  get subtitleClassic() {
    return '32 x 30 in | + ';
  }

  get cost() {
    let totalToPay = 0;
    if (this.passengerCarryOn) {
      this.passengerCarryOn.bagStackCarryon.map((bag) => {
        if (bag.status == StatusBag.TO_PAY) {
          totalToPay += bag.currencyPerLeg[0]?.currency?.total;
        }
      });
    }
    return totalToPay;
  }

  get usaPaasenger() {
    let validate = false;
    if (this.reservationold?.flightSummary?.regionKey == 'USA') {
      validate = true;
    }
    return validate;
  }
}
